<template>
	<div>
		<n-button type="info" @click="handleButtonClick">
			{{ buttonText }}
			<template #icon>
				<n-icon><i-carbon-phone-filled /></n-icon>
			</template>
		</n-button>
	</div>
	<n-modal
		v-model:show="showModal"
		preset="card"
		class="w-auto max-w-[min(550px,_calc(100vw_-_16px))] my-5"
	>
		<template #header>{{ t$.title.replace('%%MINISITE_NAME%%', minisite.name) }}</template>
		<div class="flex flex-col gap-7">
			<p>
				<span class="font-medium">{{ t$.found_on_asiagoit }}</span>
				{{ t$.phone_description }}
			</p>
			<div
				class="flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-around gap-4 sm:gap-5"
			>
				<n-button
					type="primary"
					text
					size="large"
					tag="a"
					:href="`tel:${decodedValue.replace(/[^0-9]/g, '')}`"
				>
					<template #icon>
						<n-icon size="28"><i-carbon-phone-filled /></n-icon>
					</template>
					<p
						class="text-xl min-[450px]:text-2xl font-medium leading-none relative -top-0.5 pl-2 underline"
					>
						{{ decodedValue }}
					</p>
				</n-button>
				<span class="italic hidden sm:block">{{ t$.or }}</span>
				<n-button
					type="primary"
					text
					size="large"
					tag="a"
					:href="`https://www.asiago.it/it/r/minisito/${minisite.id}/contatti`"
					target="_blank"
				>
					<template #icon>
						<n-icon size="28" class="-rotate-[25deg]"><i-mdi-email-fast /></n-icon>
					</template>
					<p
						class="text-xl min-[450px]:text-2xl font-medium leading-none relative -top-0.5 pl-2 underline"
					>
						{{ t$.send_message }}
					</p>
				</n-button>
			</div>
			<p>
				<span>{{ t$.message_form }}</span>
				<n-button
					text
					type="primary"
					tag="a"
					:href="`https://www.asiago.it/it/r/minisito/${minisite.id}/contatti`"
					target="_blank"
				>
					&nbsp;{{ t$.contact_page }}&nbsp;
				</n-button>
				<span>{{ t$.happy_to_help }}</span>
			</p>
		</div>
	</n-modal>
</template>

<script setup>
	import {NButton, NModal, NIcon} from 'naive-ui'
	import ICarbonPhoneFilled from '~icons/carbon/phone-filled'
	import IMdiEmailFast from '~icons/mdi/email-fast'
	import {getTranslations} from './translations'
	import {ref, computed, toRefs} from 'vue'

	const props = defineProps({
		minisite: Object,
		language: Object,
		value: String,
	})
	const {minisite, language, value} = toRefs(props)

	const t$ = getTranslations(language.value.id)
	const decodedValue = window.atob(value.value)
	const showModal = ref(false)

	const buttonText = computed(() => {
		return decodedValue.substring(0, 6) + '…'
	})

	function handleButtonClick() {
		// todo: save log interazioni

		showModal.value = true
	}
</script>
